var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarrantyDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 28,
    viewBox: "0 0 27 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_128_148)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.97998 5.65523V14.1545C2.97998 22.4922 12.9218 26.5859 13.3451 26.753C13.4119 26.7808 13.4843 26.792 13.5511 26.792C13.618 26.792 13.6904 26.7808 13.7572 26.753C14.1805 26.5803 24.1223 22.4866 24.1223 14.1545V5.65523C24.1223 5.36561 23.8995 5.12611 23.6155 5.09826C23.5653 5.09269 18.7198 4.61928 13.902 0.742813C13.6959 0.581294 13.4063 0.581294 13.2058 0.742813C8.39923 4.60814 3.53694 5.09269 3.48682 5.09826C3.20277 5.12611 2.97998 5.36561 2.97998 5.65523ZM4.09391 6.13978C5.48074 5.92257 9.46303 5.04814 13.5511 1.88459C17.6392 5.04814 21.6215 5.92257 23.0084 6.13978V14.1545C23.0084 21.1054 14.9603 25.0041 13.5511 25.6335C12.142 25.0041 4.09391 21.1109 4.09391 14.1545V6.13978Z",
    fill: "#214A46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8686 16.633C11.98 16.7444 12.1192 16.7945 12.2641 16.7945C12.4089 16.7945 12.5481 16.7388 12.6595 16.633L19.0089 10.2836C19.2261 10.0664 19.2261 9.71548 19.0089 9.49827C18.7917 9.28105 18.4408 9.28105 18.2236 9.49827L12.2641 15.4522L8.88329 12.0714C8.66607 11.8542 8.31519 11.8542 8.09797 12.0714C7.88075 12.2887 7.88075 12.6395 8.09797 12.8568L11.8686 16.633Z",
    fill: "#214A46"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_128_148"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26.7342,
    height: 26.7342,
    fill: "white",
    transform: "translate(0.183594 0.341797)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarrantyDark);
export default __webpack_public_path__ + "static/media/warranty-dark.96248b527b9bc0f826966893119dc0be.svg";
export { ForwardRef as ReactComponent };